import {
  getManifestPageLocale,
  getManifestSectionLocale,
  manifestResourcePages,
  manifestSections,
} from "./manifestPages";

const resolveResourcePage = (pageOrSlug) => {
  if (pageOrSlug && typeof pageOrSlug === "object" && pageOrSlug.slug) {
    return pageOrSlug;
  }

  return manifestResourcePages.find((page) => page.slug === pageOrSlug) || null;
};

const resolveResourceSection = (sectionOrKeyOrPage) => {
  if (!sectionOrKeyOrPage) {
    return null;
  }

  if (typeof sectionOrKeyOrPage === "object") {
    if (sectionOrKeyOrPage.key && Array.isArray(sectionOrKeyOrPage.items)) {
      return sectionOrKeyOrPage;
    }

    if (sectionOrKeyOrPage.sectionKey) {
      return (
        manifestSections.find(
          (section) => section.key === sectionOrKeyOrPage.sectionKey,
        ) || null
      );
    }

    if (sectionOrKeyOrPage.slug) {
      const page = resolveResourcePage(sectionOrKeyOrPage);
      return page
        ? manifestSections.find((section) => section.key === page.sectionKey) ||
            null
        : null;
    }
  }

  const directMatch = manifestSections.find(
    (section) => section.key === sectionOrKeyOrPage,
  );

  if (directMatch) {
    return directMatch;
  }

  const page = resolveResourcePage(sectionOrKeyOrPage);
  return page
    ? manifestSections.find((section) => section.key === page.sectionKey) ||
        null
    : null;
};

export const resourcePages = manifestResourcePages;

export const resourceNavigationPages = [...resourcePages].sort(
  (left, right) => {
    if (left.sectionOrder !== right.sectionOrder) {
      return left.sectionOrder - right.sectionOrder;
    }

    return left.pageOrder - right.pageOrder;
  },
);

export const getResourceSectionLabelKey = (pageOrSlug) =>
  resolveResourceSection(pageOrSlug)?.labelKey || null;

export const getLocalizedSectionTitle = (sectionOrKey, t) => {
  const section = resolveResourceSection(sectionOrKey);
  const locale = getManifestSectionLocale(section);

  if (locale?.name) {
    return locale.name;
  }

  if (section?.labelKey && typeof t === "function") {
    return t(section.labelKey);
  }

  return section?.key || "";
};

export const groupResourcePagesBySection = (pages) => {
  const grouped = manifestSections.map((section) => ({
    key: section.key,
    labelKey: section.labelKey || null,
    locales: section.locales,
    items: [],
  }));

  pages.forEach((page) => {
    const section = grouped.find((entry) => entry.key === page.sectionKey);
    if (section) {
      section.items.push(page);
    }
  });

  return grouped.filter((section) => section.items.length > 0);
};

export const getResourceBySlug = (slug) => resolveResourcePage(slug);

export const getLocalizedPageTitle = (page, t) => {
  const locale = getManifestPageLocale(page);

  if (locale?.title) {
    return locale.title;
  }

  return page?.title || "";
};

export const getLocalizedPageDescription = (page, t) => {
  const locale = getManifestPageLocale(page);

  if (locale?.description) {
    return locale.description;
  }

  return page?.description || "";
};

export const getLocalizedPageKeywords = (page) => {
  const locale = getManifestPageLocale(page);

  if (Array.isArray(locale?.keywords)) {
    return locale.keywords;
  }

  return Array.isArray(page?.keywords) ? page.keywords : [];
};
